import React from 'react';
import { useTranslation } from 'react-i18next';
import V2Icon from './V2Icon';

const GUIDE_SECTIONS = [
  {
    id: 'toggle',
    mock: 'header',
    titleKey: 'faq_randomizer_toggle_title',
    bodyKey: 'faq_randomizer_toggle_body',
    stepsKey: 'faq_randomizer_toggle_steps',
  },
  {
    id: 'settings',
    mock: 'settings',
    titleKey: 'faq_randomizer_settings_title',
    bodyKey: 'faq_randomizer_settings_body',
    stepsKey: 'faq_randomizer_settings_steps',
  },
] as const;

function HeaderMockup() {
  const { t } = useTranslation('translation');

  return (
    <div className="faq-randomizer-mock faq-randomizer-mock--header" aria-hidden="true">
      <div className="faq-randomizer-mock__toolbar">
        <span className="faq-randomizer-mock__search" />
        <span className="faq-randomizer-mock__tool">
          <V2Icon name="autopaste" />
        </span>
        <span className="faq-randomizer-mock__tool">
          <V2Icon name="dice" />
        </span>
        <span className="faq-randomizer-mock__tool faq-randomizer-mock__tool--active">
          <V2Icon name="dice" />
          <span className="faq-randomizer-mock__value">73</span>
        </span>
      </div>
      <div className="faq-randomizer-mock__legend">
        <span className="faq-randomizer-mock__legend-item">
          <span className="faq-randomizer-mock__tool faq-randomizer-mock__tool--tiny">
            <V2Icon name="dice" />
          </span>
          {t('faq_randomizer_legend_off')}
        </span>
        <span className="faq-randomizer-mock__legend-item">
          <span className="faq-randomizer-mock__tool faq-randomizer-mock__tool--tiny faq-randomizer-mock__tool--active">
            <V2Icon name="dice" />
            <span className="faq-randomizer-mock__value">73</span>
          </span>
          {t('faq_randomizer_legend_on')}
        </span>
      </div>
    </div>
  );
}

function SettingsMockup() {
  const { t } = useTranslation('translation');

  return (
    <div className="faq-randomizer-mock faq-randomizer-mock--settings" aria-hidden="true">
      <div className="faq-randomizer-mock__panel-head">
        <span className="faq-randomizer-mock__panel-icon">
          <V2Icon name="dice" />
        </span>
        <span className="faq-randomizer-mock__panel-title">{t('randomizer')}</span>
      </div>
      <div className="faq-randomizer-mock__fields">
        <label className="faq-randomizer-mock__field">
          <span>{t('range_from')}</span>
          <span className="faq-randomizer-mock__input">0</span>
        </label>
        <label className="faq-randomizer-mock__field">
          <span>{t('range_to')}</span>
          <span className="faq-randomizer-mock__input">100</span>
        </label>
        <label className="faq-randomizer-mock__field">
          <span>{t('frequency')}</span>
          <span className="faq-randomizer-mock__input">5</span>
        </label>
      </div>
      <div className="faq-randomizer-mock__footer">
        <span className="faq-randomizer-mock__btn faq-randomizer-mock__btn--outline">
          {t('reset')}
        </span>
        <span className="faq-randomizer-mock__btn faq-randomizer-mock__btn--acid">
          {t('apply')} ↗
        </span>
      </div>
    </div>
  );
}

const MOCKUPS = {
  header: HeaderMockup,
  settings: SettingsMockup,
} as const;

function renderSteps(steps: string[]) {
  return (
    <ol className="faq-layout-card__steps">
      {steps.map((step) => (
        <li key={step}>{step}</li>
      ))}
    </ol>
  );
}

const V2FAQRandomizerGuide: React.FC = () => {
  const { t } = useTranslation('translation');

  return (
    <div className="faq-randomizer-guide">
      {GUIDE_SECTIONS.map(({ id, mock, titleKey, bodyKey, stepsKey }) => {
        const Mockup = MOCKUPS[mock];
        const steps = t(stepsKey, { returnObjects: true }) as string[];

        return (
          <article key={id} className={`faq-layout-card faq-layout-card--${id}`}>
            <div className="faq-layout-card__visual">
              <Mockup />
            </div>
            <div className="faq-layout-card__copy">
              <h3>{t(titleKey)}</h3>
              <p className="faq-layout-card__lead">{t(bodyKey)}</p>
              {Array.isArray(steps) && steps.length > 0 ? renderSteps(steps) : null}
            </div>
          </article>
        );
      })}
      <aside className="faq-layout-note">
        <h4>{t('faq_randomizer_defaults_title')}</h4>
        <p>{t('faq_randomizer_defaults_body')}</p>
      </aside>
    </div>
  );
};

export default V2FAQRandomizerGuide;
